// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { screenXsMax, screenMdMin, spacer16, spacer20, spacer32, spacer40, spacer56 } from '@spotify-internal/encore-web';
import { HeadlineWithSupertextComponent, ImageAspectBox16x9 } from '../../ui';
import { ShareButtonsComponent as ShareButtons } from '../../ui/ShareButtons';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var maxWidthOfImage = '984px';
var maxWidthOfText = '660px';
var ArticleHeader = styled.div.withConfig({
  displayName: "ArticleHeaderModule__ArticleHeader",
  componentId: "p3wl77-0"
})(["display:flex;flex-direction:column;justify-content:center;padding-top:100px;padding-left:", ";padding-right:", ";padding-bottom:", ";color:", ";background-color:", ";@media (max-width:", "){padding:", " ", " ", " ", ";}"], spacer40, spacer40, spacer32, function (_ref) {
  var textColor = _ref.textColor;
  return textColor;
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, screenXsMax, spacer56, spacer20, spacer16, spacer20);
var ImageContainer = styled(ImageAspectBox16x9).withConfig({
  displayName: "ArticleHeaderModule__ImageContainer",
  componentId: "p3wl77-1"
})(["max-width:", ";width:75%;margin:auto;@media (max-width:", "){width:100%;}"], maxWidthOfImage, screenMdMin);
var Bottom = styled.div.withConfig({
  displayName: "ArticleHeaderModule__Bottom",
  componentId: "p3wl77-2"
})(["display:flex;flex-direction:column;justify-content:center;padding-top:", ";align-items:center;a:last-child{padding-right:0;}.addthis_toolbox{padding-bottom:0;}@media (max-width:", "){justify-content:space-between;}"], spacer32, screenXsMax);
var AuthorDate = styled.div.withConfig({
  displayName: "ArticleHeaderModule__AuthorDate",
  componentId: "p3wl77-3"
})(["padding-bottom:", ";"], spacer20);
var TextContainer = styled.div.withConfig({
  displayName: "ArticleHeaderModule__TextContainer",
  componentId: "p3wl77-4"
})(["max-width:", ";margin:auto;& div > p{padding-top:", ";}& div > h1{padding-top:", ";text-align:center;}"], maxWidthOfText, spacer20, spacer16);
export var ArticleHeaderModule = function ArticleHeaderModule(_ref3) {
  var _ref3$headline = _ref3.headline,
      headline = _ref3$headline === void 0 ? '' : _ref3$headline,
      _ref3$supertext = _ref3.supertext,
      supertext = _ref3$supertext === void 0 ? '' : _ref3$supertext,
      image = _ref3.image,
      _ref3$authorDateStrin = _ref3.authorDateString,
      authorDateString = _ref3$authorDateStrin === void 0 ? '' : _ref3$authorDateStrin,
      _ref3$backgroundColor = _ref3.backgroundColor,
      backgroundColor = _ref3$backgroundColor === void 0 ? '' : _ref3$backgroundColor,
      _ref3$textColor = _ref3.textColor,
      textColor = _ref3$textColor === void 0 ? '' : _ref3$textColor;
  return /*#__PURE__*/_jsxs(ArticleHeader, {
    backgroundColor: backgroundColor,
    textColor: textColor,
    children: [/*#__PURE__*/_jsx(TextContainer, {
      children: /*#__PURE__*/_jsx(HeadlineWithSupertextComponent, {
        centered: true,
        headline: headline,
        supertext: supertext,
        text: textColor,
        background: backgroundColor
      })
    }), image && /*#__PURE__*/_jsx(ImageContainer, {
      children: /*#__PURE__*/_jsx(ContentfulImage, {
        asset: image
      })
    }), /*#__PURE__*/_jsxs(Bottom, {
      children: [/*#__PURE__*/_jsx(AuthorDate, {
        children: authorDateString
      }), /*#__PURE__*/_jsx(ShareButtons, {
        textColor: textColor
      })]
    })]
  });
};